const strip_tags = (str, allowed_tags = '', allowed_attributes) => {
  // Parse allowed tags into an array
  const allowedTagList = allowed_tags.match(/([a-zA-Z0-9]+)/gi) || [];
  // Parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');

  // Recursive function to clean nodes
  function clean(node, insideSvg = false) {
    // If it's an element node
    if (node.nodeType === 1) {
      const tagName = node.tagName.toLowerCase();
      // If inside <svg> and <svg> is allowed, keep all nested tags and attributes
      if (insideSvg && allowedTagList.includes('svg')) {
        // Do not clean further, just return
        return;
      }
      // If tag is not allowed, remove it but keep its children
      if (!allowedTagList.includes(tagName)) {
        const parent = node.parentNode;
        while (node.firstChild) {
          parent.insertBefore(node.firstChild, node);
        }
        parent.removeChild(node);
        return;
      }
      // Remove disallowed attributes only if allowed_attributes is defined and non-empty
      if (Array.isArray(allowed_attributes) && allowed_attributes.length > 0) {
        [...node.attributes].forEach((attr) => {
          if (!allowed_attributes.includes(attr.name)) {
            node.removeAttribute(attr.name);
          }
        });
      }
      // If allowed_attributes is undefined or empty, keep all attributes
      // If this is an <svg> tag, set insideSvg to true for children
      insideSvg = tagName === 'svg' ? true : insideSvg;
    }
    // Clean child nodes recursively
    [...node.childNodes].forEach((child) => clean(child, insideSvg));
  }

  // Start cleaning from body
  [...doc.body.childNodes].forEach(clean);
  return doc.body.innerHTML;
};

export default strip_tags;
